import { render } from "./InspectionChecks.vue?vue&type=template&id=9210b13e"
import script from "./InspectionChecks.vue?vue&type=script&lang=js"
export * from "./InspectionChecks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__